<template>
  <section class="workspace-stack">
    <article class="glass-surface workspace-panel">
      <div class="workspace-panel__header">
        <div>
          <span class="workspace-kicker">Ordenes sin pago</span>
          <h2 class="workspace-title">Revision manual y emision de tickets</h2>
          <p class="workspace-copy">Estas ordenes ya tienen factura y entradas, pero aun no tienen pago registrado. Al confirmar se crea el pago, se genera el QR con el diseno final y se envia por correo.</p>
        </div>
      </div>

      <div class="workspace-metrics">
        <article class="workspace-metric">
          <small>Ordenes sin pago</small>
          <strong>{{ filteredEvents.length }}</strong>
        </article>
        <article class="workspace-metric">
          <small>Monto por regularizar</small>
          <strong>{{ formatMoney(pendingTotalAmount, dominantCurrency) }}</strong>
        </article>
        <article class="workspace-metric">
          <small>Con método listo</small>
          <strong>{{ readyToConfirmCount }}</strong>
        </article>
        <article class="workspace-metric">
          <small>Monedas</small>
          <strong>{{ currencySummary }}</strong>
        </article>
      </div>

      <div class="workspace-toolbar">
        <label class="workspace-search">
          <i class="fas fa-search"></i>
          <input v-model="search" type="text" placeholder="Buscar por nombre, correo o evento" />
        </label>
      </div>

      <p v-if="error" class="workspace-feedback workspace-feedback--error">{{ error }}</p>
      <p v-if="success" class="workspace-feedback workspace-feedback--success">{{ success }}</p>

      <div v-if="!filteredEvents.length" class="workspace-empty">No hay ordenes sin pago pendientes.</div>
      <div v-else class="workspace-table-shell">
        <table class="workspace-table manual-table">
          <thead>
            <tr>
              <th>Factura</th>
              <th>Cliente</th>
              <th>Evento</th>
              <th>Tickets</th>
              <th>Cobro</th>
              <th>Revision</th>
              <th>Metodo final</th>
              <th>Accion</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="invoice in filteredEvents" :key="invoice.id">
              <td>
                <div class="manual-stack">
                  <strong>#{{ invoice.id }}</strong>
                  <small>{{ formatDate(invoice.date) }}</small>
                  <span>{{ invoiceCurrency(invoice) }}</span>
                </div>
              </td>
              <td>
                <div class="manual-stack">
                  <strong>{{ invoice.user || 'Sin nombre' }}</strong>
                  <small>{{ invoice.email || 'Sin correo' }}</small>
                </div>
              </td>
              <td>
                <div class="manual-stack" :title="displayEventHelper(invoice)">
                  <strong>{{ displayEventName(invoice) }}</strong>
                  <small>{{ displayEventHelper(invoice) }}</small>
                </div>
              </td>
              <td>
                <div class="manual-stack">
                  <strong>{{ invoice.ticket_count || 0 }}</strong>
                  <small>{{ invoice.payment_count || 0 }} pagos previos</small>
                </div>
              </td>
              <td>
                <div class="manual-stack">
                  <strong>{{ formatMoney(invoice.total, invoiceCurrency(invoice)) }}</strong>
                  <small>Subtotal {{ formatMoney(invoice.subtotal, invoiceCurrency(invoice)) }}</small>
                  <small>Fee {{ formatMoney(invoice.fee, invoiceCurrency(invoice)) }}</small>
                </div>
              </td>
              <td>
                <span class="workspace-status-pill is-warning">{{ invoice.manual_review_reason || 'Sin pago registrado' }}</span>
              </td>
              <td>
                <div class="manual-stack manual-stack--field">
                  <select v-model.number="invoice.selected_payment_type" class="workspace-input workspace-select manual-select">
                  <option :value="0">Selecciona</option>
                  <option :value="3">Tarjeta credito</option>
                  <option :value="6">Tarjeta debito</option>
                  <option :value="4">PayPal</option>
                  <option :value="2">Transferencia</option>
                  <option :value="5">POS</option>
                  <option :value="1">Efectivo</option>
                  <option :value="7">Rechazar</option>
                  </select>
                  <small>Sugerido: {{ paymentSelectionLabel(inferSelectedPaymentType(invoice)) }}</small>
                </div>
              </td>
              <td>
                <div class="manual-actions">
                  <button class="workspace-button workspace-button--primary workspace-button--small" type="button" :disabled="loading || resolveSelectedPaymentType(invoice) === 0" @click="createPayment(invoice)">
                    <i class="fas fa-check"></i>
                    <span>Generar y enviar</span>
                  </button>
                  <button v-if="invoice.event_id" class="workspace-button workspace-button--small" type="button" @click="openInvoiceEvent(invoice)">
                    <i class="fas fa-calendar-alt"></i>
                    <span>Abrir evento</span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="workspace-actions workspace-actions--end">
        <spring-spinner v-if="loading" v-show="next" :size="48" color="#8cf3e8" />
        <button v-show="next && !loading" class="workspace-button" type="button" @click="getEvents">Cargar mas</button>
      </div>
    </article>
  </section>
</template>

<script>
import { apiService } from "../../common/api.services.js";
import { SpringSpinner } from 'epic-spinners';
import { apiServiceForm } from "../../common/api.services.js";
import { formatCurrencyAmount, normalizeCurrencyCode } from '../../common/currency.js'


export default {
  name: "PendingPaymentList",
  data() {
    return {
      events: [],
      next: null,
      loadingTable: true,
      search: "",
      loading: false,
      promoter_table:[],
      is_staff:localStorage.getItem('is_staff'),
      payment_type:0,
      bank_fee: 0,
      revenue_fee: 0,
      payment_t:0,
      error: '',
      success: ''
    };
  },
  components: {
    SpringSpinner,
  },

  computed: {
    filteredEvents() {
      const term = this.search.trim().toLowerCase()
      if (!term) {
        return this.events
      }

      return this.events.filter((invoice) => {
        const haystack = `${invoice.user || ''} ${invoice.email || ''} ${invoice.event || ''}`.toLowerCase()
        return haystack.includes(term)
      })
    },

    pendingTotal() {
      const total = this.filteredEvents.reduce((sum, invoice) => sum + (Number.parseFloat(invoice.total) || 0), 0)
      return total.toFixed(2)
    },

    pendingTotalAmount() {
      return this.filteredEvents.reduce((sum, invoice) => sum + (Number.parseFloat(invoice.total) || 0), 0)
    },

    readyToConfirmCount() {
      return this.filteredEvents.filter((invoice) => this.resolveSelectedPaymentType(invoice) !== 0).length
    },

    currencySummary() {
      const currencies = [...new Set(this.filteredEvents.map((invoice) => this.invoiceCurrency(invoice)).filter(Boolean))]
      return currencies.length ? currencies.join(' / ') : 'USD'
    },

    dominantCurrency() {
      return this.filteredEvents[0] ? this.invoiceCurrency(this.filteredEvents[0]) : 'USD'
    },
  },

  created() {
    this.getEvents();
  },

  methods: {


    
    formatMoney(value, currency = 'USD') {
      return formatCurrencyAmount(value, currency)
    },

    invoiceCurrency(invoice) {
      return normalizeCurrencyCode(invoice && ((invoice.pricing_snapshot && invoice.pricing_snapshot.currency) || invoice.currency || 'USD'))
    },

    displayEventName(invoice) {
      if (invoice && invoice.event) return invoice.event
      if (invoice && invoice.event_name) return invoice.event_name
      if (invoice && invoice.pricing_snapshot && invoice.pricing_snapshot.event_name) return invoice.pricing_snapshot.event_name
      return invoice && invoice.pos ? `POS #${invoice.pos}` : 'Sin evento'
    },

    displayPos(invoice) {
      const parts = []
      if (invoice && invoice.pos) parts.push(`Punto de venta #${invoice.pos}`)
      if (invoice && invoice.payment_option) parts.push(`Opcion pago #${invoice.payment_option}`)
      return parts.length ? parts.join(' · ') : 'Sin POS'
    },

    displayEventHelper(invoice) {
      const parts = []
      if (invoice && invoice.event_id) parts.push(`Evento #${invoice.event_id}`)
      if (invoice && invoice.event_slug) parts.push(invoice.event_slug)
      const posLabel = this.displayPos(invoice)
      if (posLabel && posLabel !== 'Sin POS') parts.push(posLabel)
      return parts.length ? parts.join(' · ') : 'Sin datos de evento'
    },

    paymentSelectionLabel(value) {
      const labels = {
        0: 'Sin definir',
        1: 'Efectivo',
        2: 'Transferencia',
        3: 'Tarjeta credito',
        4: 'PayPal',
        5: 'POS',
        6: 'Tarjeta debito',
        7: 'Rechazar',
      }
      return labels[Number(value || 0)] || 'Sin definir'
    },

    inferSelectedPaymentType(invoice) {
      const optionId = Number(invoice && invoice.payment_option ? invoice.payment_option : 0)
      const map = {
        1: 4,
        2: 2,
        3: 3,
        4: 2,
        5: 3,
        6: 3,
        7: 3,
        8: 2,
      }
      return map[optionId] || 0
    },

    resolveSelectedPaymentType(invoice) {
      return Number(invoice.selected_payment_type || this.inferSelectedPaymentType(invoice) || 0)
    },

    createPayment(invoice) {
this.error = ''
this.success = ''

const index = this.events.findIndex((item) => item.id === invoice.id)
if (index === -1) {
  return
}

const selectedPaymentType = this.resolveSelectedPaymentType(invoice)
invoice.selected_payment_type = selectedPaymentType
if (selectedPaymentType === 0) {
  this.error = 'Debes seleccionar el metodo final antes de confirmar.'
  return
}



let status_final = 1
this.loading=true
  let  endpoint =  `/api/manual-p/?tran_id=fomoaut`

  if (selectedPaymentType==1){
    this.bank_fee=0
    this.payment_t=1
  }else if(selectedPaymentType==2){
    this.bank_fee=0
    this.payment_t=2
  }else if(selectedPaymentType==3){
    this.payment_t=3
  let dataF=(parseFloat(this.events[index].total)*0.015)
   this.bank_fee= (parseFloat(this.events[index].total)*0.0448)+ dataF + (dataF*0.12)
  }else if(selectedPaymentType==4){
    this.bank_fee=(parseFloat(this.events[index].total)*0.054)+0.30
    this.payment_t=3


  }else if (selectedPaymentType==5){

    this.bank_fee= (parseFloat(this.events[index].total)*0.0448)
    this.payment_t=5



  }else if(selectedPaymentType==6){
   let  dataF=(parseFloat(this.events[index].total)*0.005)
   this.bank_fee= (parseFloat(this.events[index].total)*0.0225)+dataF + (dataF*0.12)
   this.payment_t=3
  
  }else if(selectedPaymentType==7){
   let  dataF=(parseFloat(this.events[index].total)*0.005)
   this.bank_fee= (parseFloat(this.events[index].total)*0.0225)+dataF + (dataF*0.12)
   this.payment_t=1
   status_final=4
  }


  const data = new FormData()
  
  data.append('amount', this.events[index].total)
  data.append('invoice', this.events[index].id)
  data.append('point_of_sale', this.events[index].pos)
  data.append('url', "")
  data.append('url_number', "")
  data.append('comment', "Ingreso Manual")
  data.append('subtotal', this.events[index].subtotal)
  data.append('fee', this.events[index].fee)
  
 
 
  if (selectedPaymentType==2){
  this.revenue_fee=this.events[index].fee
  }else{
    this.revenue_fee=parseFloat(this.events[index].fee)-parseFloat(this.bank_fee)
    this.revenue_fee=this.revenue_fee.toFixed(2)
  }


     this.bank_fee=parseFloat(this.bank_fee).toFixed(2)


     data.append('bank_fee', this.bank_fee)
     data.append('revenue_fee', this.revenue_fee)

  
  data.append('ticket',"")
  data.append('payment_selection', selectedPaymentType)
  data.append('payment_type',   this.payment_t)
  data.append('status', status_final)
  data.append('is_manual', 1)


   apiServiceForm(endpoint, "POST", data)
         .then((response) => {
           this.loading=false
           if (response && response.err) {
             this.error = response.err
             return
           }

           const ticketState = response && response.ticket_generated ? ' Ticket generado.' : ' Ticket pendiente de generar.'
           const emailState = response && response.email_sent ? ' Correo enviado.' : (response && response.ticket_generated ? ' Correo pendiente de envio.' : '')
           const warnings = [response && response.ticket_error, response && response.email_error].filter(Boolean).join(' ')
           this.success = `Pago manual registrado para la factura #${invoice.id}.${ticketState}${emailState}${warnings ? ` ${warnings}` : ''}`
           this.events.splice(index, 1)






         }).catch(() => {

    this.loading=false
    this.error = 'Error al ingresar el pago. Revisa el método seleccionado o intenta de nuevo.'

    alert("Error al ingresar el pago. Por favor comunícate con nosotros para revisar el caso.")
    //alert('Ha ocurrido un ERROR al actualizar el perfil. Inténtelo nuevamente.  SUDEN - CURSOS CON BOLSA DE EMPLEO')
    //window.location.href = "https://www.somossuden.com/inicio/student-registration.html";


  })
  
 //Ver si el usuario tiene cursos adicionales...
// if (this.event.id==16){
//  this.print()

  
// }

 //Cambiar contraseña y estado del usuario a activado...


},




    changeStatus(index){
    this.success = false

    let id = this.events[index].id


    let endpoint =  `/api/payment/${id}/change?type=${this.events[index].status}`
    apiService(endpoint, "PUT")
              .then(data => {
                  if (data.id){
                    this.events.splice(index, 1)
                  }else{
                      //Especificar error
                      this.error=data.err
                  }

    
              })


    
    },





    formatDate(dateString){
              const date = new Date(dateString);
                // Then specify how you want your dates to be formatted
            return new Intl.DateTimeFormat('default', {dateStyle: 'short'}).format(date);
    },



    populateBar() {
      this.generatedBar = {
        labels: ["Tarjeta", "Transferencia", "Efectivo"],
        datasets: [
          {
            label: "$",
            backgroundColor: "blue",
            data: [this.card, this.bank, this.cash],
          },
        ],
      };
    },

    populateData() {
      let labelArr = [];
      let backgroundColorArr = [];
      let dataArr = [];

      for (let index = 0; index < this.eventTickets.length; index++) {
        let lname =
          this.eventTickets[index].name + "-" + this.eventTickets[index].code;
        labelArr.push(lname);

        let maxVal = 0xffffff; // 16777215
        let randomNumber = Math.random() * maxVal;
        randomNumber = Math.floor(randomNumber);
        randomNumber = randomNumber.toString(16);
        let randColor = randomNumber.padStart(6, 0);
        let color = `#${randColor.toUpperCase()}`;
        backgroundColorArr.push(color);

        let value =
          this.eventTickets[index].initial_quantity -
          this.eventTickets[index].remaining_tickets;
        dataArr.push(value);

        let obj = Object();
        obj.section =
          this.eventTickets[index].name + "-" + this.eventTickets[index].code;
        obj.tickets = value;
        obj.remaining = this.eventTickets[index].remaining_tickets;
        this.total_tickets.push(obj);
       }
       this.loadingTable = false;

      this.generatedData = {
        labels: labelArr,
        datasets: [
          {
            label: "Tickets x Sección",
            backgroundColor: backgroundColorArr,
            data: dataArr,
          },
        ],
      };
    },

    openEvent(_id) {
      this.$router.push({ name: "EventHostView", params: { slug: _id } });
    },

    openInvoiceEvent(invoice) {
      const eventKey = invoice && (invoice.event_id || invoice.event_slug)
      if (!eventKey) return
      this.openEvent(eventKey)
    },

    searchEvents() {
      this.events = [];
      this.getEvents();
      this.next = null;
    },

    populateDataS(){

      

        let money_count=0
        let sale_count=0


        let array= this.events
        let code_n=array[0].product_code


      





        for (let index = 0; index < array.length; index++) {
          if (array[index].product_code==code_n){
          money_count=parseFloat(money_count)+parseFloat(array[index].amount)
          sale_count++;
         
        }else{
          let payment_obj = Object()
          payment_obj.money=money_count
          payment_obj.code=array[index].product_code
          payment_obj.count=sale_count


          this.promoter_table.push(payment_obj)
          money_count=0
          sale_count=0
          code_n=array[index].product_code

        }
        }
    },

    getEvents() {
      // make a GET Request to the questions list endpoint and populate the questions array

      //tipo 1 para generico y tipo 2 para mis cursos y usar el mismo componente
      let endpoint = "/api/invoices-data/?status=pending";
       

      if (this.next) {
        endpoint = this.next;
        this.loading=true
      }
      this.loadingQuestions = true;
      apiService(endpoint).then((data) => {
        const items = Array.isArray(data) ? data : (data && data.results ? data.results : [])
        this.events = this.events.concat(items.map((item) => ({ ...item, selected_payment_type: item.selected_payment_type || this.inferSelectedPaymentType(item) })));
        this.showLoading = false;
        this.loading=false
        if (data && data.next) {
          //si no es null
          this.next = data.next;
        } else {
          //Si no es null
          this.next = null;
        }
       // this.populateDataS()
      });

      
    
    
    },

  },
};
</script>

<style scoped>
.workspace-table-shell {
  overflow: auto;
}

.workspace-table {
  width: 100%;
  border-collapse: collapse;
}

.workspace-table th,
.workspace-table td {
  padding: 14px 12px;
  border-bottom: 1px solid rgba(223, 214, 255, 0.08);
  text-align: left;
  color: var(--text-soft);
}

.workspace-table th {
  color: var(--text-main);
  font-size: 0.75rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.manual-table td {
  vertical-align: top;
}

.manual-stack {
  display: grid;
  gap: 4px;
}

.manual-stack strong {
  color: var(--text-main);
}

.manual-stack small,
.manual-stack span {
  color: var(--text-soft);
}

.manual-stack--field {
  min-width: 220px;
}

.manual-select {
  min-width: 220px;
}

.manual-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 220px;
}

.manual-actions .workspace-button {
  flex: 1 1 150px;
}

@media (max-width: 920px) {
  .manual-select,
  .manual-stack--field,
  .manual-actions {
    min-width: 180px;
  }
}
</style>
